


// import React, { useState, useEffect } from 'react';
// import './Project.css';
// import Navbar from '../Navbar/Navbar';
// import Footer from '../Footer/Footer';

// const Project = () => {
//   const [projects, setProjects] = useState([]);
//   const [filteredProjects, setFilteredProjects] = useState([]);

//   const [selectedCategory, setSelectedCategory] = useState('');
//   const [selectedCountry, setSelectedCountry] = useState('');

//   const [categories, setCategories] = useState([]);
//   const [countries, setCountries] = useState([]);

//   // Fetch Projects From API
//   useEffect(() => {
//     fetch( "https://api.info-sight.net/api/projects")
//       .then((res) => res.json())
//       .then((data) => {
//         setProjects(data);
//         setFilteredProjects(data);

//         // Extract unique categories
//         const uniqueCategories = [
//           ...new Set(data.map((item) => item.category)),
//         ];
//         setCategories(uniqueCategories);

//         // Extract unique countries
//         const uniqueCountries = [
//           ...new Set(data.map((item) => item.country)),
//         ];
//         setCountries(uniqueCountries);
//       })
//       .catch((error) => console.error("Error fetching projects:", error));
//   }, []);

//   // Filter Projects on filter change
//   useEffect(() => {
//     let filtered = projects;

//     if (selectedCategory) {
//       filtered = filtered.filter(
//         (project) => project.category === selectedCategory
//       );
//     }

//     if (selectedCountry) {
//       filtered = filtered.filter(
//         (project) => project.country === selectedCountry
//       );
//     }

//     setFilteredProjects(filtered);
//   }, [selectedCategory, selectedCountry, projects]);

//   return (
//     <>
//       <Navbar />

//       <div className="project-container">
//         <div className="project-wrapper">
          
//           {/* Sidebar Filters */}
//           <aside className="project-sidebar">
//             <h2 className="sidebar-title">Filter Projects</h2>

//             {/* Category Filter */}
//             <div className="filter-group">
//               <label>Category</label>
//               <select
//                 value={selectedCategory}
//                 onChange={(e) => setSelectedCategory(e.target.value)}
//               >
//                 <option value="">All Categories</option>
//                 {categories.map((cat, index) => (
//                   <option key={index} value={cat}>
//                     {cat}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Country Filter */}
//             <div className="filter-group">
//               <label>Country</label>
//               <select
//                 value={selectedCountry}
//                 onChange={(e) => setSelectedCountry(e.target.value)}
//               >
//                 <option value="">All Countries</option>
//                 {countries.map((country, index) => (
//                   <option key={index} value={country}>
//                     {country}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </aside>

//           {/* Projects Display */}
//           <main className="project-main">
//             <h2 className="project-title">
//               Projects ({filteredProjects.length})
//             </h2>

//             <div className="project-grid">
//               {filteredProjects.map((project) => (
//                 <div key={project.id} className="project-card">
//                   <img
//                     src={project.image}
//                     alt={project.name}
//                     className="project-image"
//                   />
//                   <h3 className="project-name">{project.name}</h3>
//                   <p className="project-meta">{project.category}</p>
//                   <p className="project-meta">{project.country}</p>
//                 </div>
//               ))}

//               {filteredProjects.length === 0 && (
//                 <p className="no-projects">No projects found.</p>
//               )}
//             </div>
//           </main>
//         </div>
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default Project;


// import React, { useState, useEffect } from 'react';
// import './Project.css';
// import Navbar from '../Navbar/Navbar';
// import Footer from '../Footer/Footer';
// import { FaArrowRight, FaMapMarkerAlt, FaTags, FaTasks } from 'react-icons/fa';

// const Project = () => {
//   const [projects, setProjects] = useState([]);
//   const [filteredProjects, setFilteredProjects] = useState([]);
//   const [selectedProject, setSelectedProject] = useState(null);

//   const [selectedCategory, setSelectedCategory] = useState('');
//   const [selectedCountry, setSelectedCountry] = useState('');

//   const [categories, setCategories] = useState([]);
//   const [countries, setCountries] = useState([]);

//   useEffect(() => {
//     fetch("https://api.info-sight.net/api/projects")
//       .then((res) => res.json())
//       .then((data) => {
//         setProjects(data);
//         setFilteredProjects(data);
//         setCategories([...new Set(data.map((item) => item.category))]);
//         setCountries([...new Set(data.map((item) => item.country))]);
//       })
//       .catch((error) => console.error("Error fetching projects:", error));
//   }, []);

//   useEffect(() => {
//     let filtered = projects;
//     if (selectedCategory) filtered = filtered.filter((p) => p.category === selectedCategory);
//     if (selectedCountry) filtered = filtered.filter((p) => p.country === selectedCountry);
//     setFilteredProjects(filtered);
//   }, [selectedCategory, selectedCountry, projects]);

//   const handleProjectClick = (project) => {
//     setSelectedProject(project);
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   const getRelatedProjects = (current) => {
//     return projects
//       .filter((p) => p.category === current.category && p.id !== current.id)
//       .slice(0, 3);
//   };

//   return (
//     <>
//       <Navbar />

//       {selectedProject ? (
//         /* --- PREMIUM DETAIL VIEW --- */
//         <div className="project-detail-container fade-in">
//           <div className="detail-hero" style={{ backgroundImage: `url(${selectedProject.image})` }}>
//             <div className="detail-hero-overlay">
//               <h1 className="detail-title">{selectedProject.name}</h1>
//               <div className="breadcrumb">
//                 <span className="breadcrumb-link" onClick={() => window.location.href='/'}>Home</span>
//                 <span className="breadcrumb-sep">/</span>
//                 <span className="breadcrumb-link" onClick={() => setSelectedProject(null)}>Projects</span>
//                 <span className="breadcrumb-sep">/</span>
//                 <span className="breadcrumb-current">{selectedProject.name}</span>
//               </div>
//             </div>
//           </div>

//           <div className="detail-content-wrapper">
// <div className="detail-split">
//   {/* IMAGE FIRST */}
//   <div className="detail-image-box">
//     <img
//       src={selectedProject.image}
//       alt={selectedProject.name}
//       className="detail-main-img"
//     />
//   </div>

//   {/* PROJECT OVERVIEW SECOND */}
//   <div className="detail-summary-card">
//     <div className="accent-line"></div>
//     <h3 className="summary-heading">Project Overview</h3>

//   <div className="summary-grid">
//   <div className="summary-item">
//     <span className="summary-label">
//       <FaMapMarkerAlt style={{ color: "#e40613", marginRight: 6 }} />
//       Location
//     </span>
//     <span className="summary-value">{selectedProject.country}</span>
//   </div>

//   <div className="summary-item">
//     <span className="summary-label">
//       <FaTags style={{ color: "#e40613", marginRight: 6 }} />
//       Category
//     </span>
//     <span className="summary-value">{selectedProject.category}</span>
//   </div>

//   <div className="summary-item full-width">
//     <span className="summary-label">
//       <FaTasks style={{ color: "#e40613", marginRight: 6 }} />
//       Scope of Work
//     </span>
//     <span className="summary-value">
//       {selectedProject.scope_of_work}
//     </span>
//   </div>
// </div>


//     {selectedProject.description && (
//       <div className="detail-description">
//         <p>{selectedProject.description}</p>
//       </div>
//     )}
//   </div>
// </div>


//             <div className="related-section">
//               <div className="section-header">
//                 <h3 className="section-title">Related Projects</h3>
//                 <div className="section-line"></div>
//               </div>
//               <div className="related-grid">
//                 {getRelatedProjects(selectedProject).map((related) => (
//                   <div key={related.id} className="related-card" onClick={() => handleProjectClick(related)}>
//                     <div className="related-img-wrapper">
//                       <img src={related.image} alt={related.name} />
//                       <div className="related-overlay"><FaArrowRight /></div>
//                     </div>
//                     <div className="related-info">
//                       <h4>{related.name}</h4>
//                       <span>{related.category}</span>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       ) : (
//         /* --- LIST VIEW --- */
//         <div className="project-container fade-in">
//           <div className="project-wrapper">
//             <aside className="project-sidebar">
//               <h2 className="sidebar-title">Filter Projects</h2>
//               <div className="filter-group">
//                 <label>Category</label>
//                 <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
//                   <option value="">All Categories</option>
//                   {categories.map((cat, i) => <option key={i} value={cat}>{cat}</option>)}
//                 </select>
//               </div>
//               <div className="filter-group">
//                 <label>Country</label>
//                 <select value={selectedCountry} onChange={(e) => setSelectedCountry(e.target.value)}>
//                   <option value="">All Countries</option>
//                   {countries.map((c, i) => <option key={i} value={c}>{c}</option>)}
//                 </select>
//               </div>
//             </aside>

//             <main className="project-main">
//               {/* UPDATED TITLE WITH COUNT */}
//               <h2 className="project-title">
//                Projects <span className="project-count">({filteredProjects.length})</span>
//               </h2>

//               <div className="project-grid">
//                 {filteredProjects.map((project) => (
//                   <div key={project.id} className="project-card" onClick={() => handleProjectClick(project)}>
//                     <div className="card-img-container">
//                        <img src={project.image} alt={project.name} className="project-image" />
//                        <div className="card-overlay">View Details</div>
//                     </div>
//                     <div className="card-content">
//                         <h3 className="project-name">{project.name}</h3>
//                         <p className="project-meta">{project.category} | {project.country}</p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//               {filteredProjects.length === 0 && <p className="no-projects">No projects found.</p>}
//             </main>
//           </div>
//         </div>
//       )}

//       <Footer />
//     </>
//   );
// };

// export default Project;


import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import {
  FaArrowRight,
  FaMapMarkerAlt,
  FaTags,
  FaTasks,
  FaChevronRight,
  FaSearch,
  FaBuilding,
  FaRegFolderOpen,
  FaArrowLeft,
} from "react-icons/fa";

// Eye-Comfort Real Estate & Architectural Palette
const theme = {
  bgApp: "#F8FAF9",
  bgCard: "#FFFFFF",
  bgSubtle: "#F1F5F9",
  primary: "#0F172A", // Deep Slate Navy
  accent: "#0D9488", // Soft Emerald Teal
  accentLight: "#CCFBF1",
  textDark: "#1E293B",
  textMuted: "#64748B",
  border: "#E2E8F0",
  shadowSm: "0 1px 3px rgba(0, 0, 0, 0.05)",
  shadowMd: "0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.01)",
  shadowLg: "0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.02)",
};

// Global Responsive CSS Injection
const inlineStyles = `
  .project-page-root {
    background-color: ${theme.bgApp};
    color: ${theme.textDark};
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    min-height: 100vh;
  }

  /* Grid Layouts */
  .projects-layout {
    display: grid;
    grid-template-columns: 280px 1fr;
    gap: 32px;
    max-width: 1240px;
    margin: 40px auto;
    padding: 0 20px;
  }

  .projects-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 24px;
  }

  /* Property Cards */
  .project-card {
    background-color: ${theme.bgCard};
    border-radius: 16px;
    border: 1px solid ${theme.border};
    overflow: hidden;
    box-shadow: ${theme.shadowSm};
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
    display: flex;
    flex-direction: column;
  }

  .project-card:hover {
    transform: translateY(-6px);
    box-shadow: ${theme.shadowMd};
    border-color: ${theme.accent};
  }

  .project-card-img-wrapper {
    position: relative;
    height: 220px;
    overflow: hidden;
  }

  .project-card-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  .project-card:hover .project-card-img {
    transform: scale(1.05);
  }

  .project-badge {
    position: absolute;
    top: 14px;
    left: 14px;
    background: rgba(15, 23, 42, 0.8);
    backdrop-filter: blur(4px);
    color: #FFFFFF;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
  }

  .project-card-body {
    padding: 20px;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  /* Detail Page Styles */
  .detail-hero-banner {
    position: relative;
    height: 380px;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: flex-end;
  }

  .detail-hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(15, 23, 42, 0.2) 0%, rgba(15, 23, 42, 0.85) 100%);
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 40px 20px;
  }

  .detail-split-container {
    display: grid;
    grid-template-columns: 1.2fr 0.8fr;
    gap: 32px;
    max-width: 1240px;
    margin: 40px auto;
    padding: 0 20px;
  }

  @media (max-width: 992px) {
    .projects-layout {
      grid-template-columns: 1fr;
    }
    .detail-split-container {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 600px) {
    .detail-hero-banner {
      height: 280px;
    }
    .projects-grid {
      grid-template-columns: 1fr;
    }
  }
`;

const Project = () => {
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const [categories, setCategories] = useState([]);
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    fetch("https://api.info-sight.net/api/projects")
      .then((res) => res.json())
      .then((data) => {
        setProjects(data);
        setFilteredProjects(data);
        setCategories([...new Set(data.map((item) => item.category).filter(Boolean))]);
        setCountries([...new Set(data.map((item) => item.country).filter(Boolean))]);
      })
      .catch((error) => console.error("Error fetching projects:", error));
  }, []);

  useEffect(() => {
    let filtered = projects;
    if (selectedCategory) filtered = filtered.filter((p) => p.category === selectedCategory);
    if (selectedCountry) filtered = filtered.filter((p) => p.country === selectedCountry);
    if (searchQuery) {
      filtered = filtered.filter((p) =>
        p.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (p.scope_of_work && p.scope_of_work.toLowerCase().includes(searchQuery.toLowerCase()))
      );
    }
    setFilteredProjects(filtered);
  }, [selectedCategory, selectedCountry, searchQuery, projects]);

  const handleProjectClick = (project) => {
    setSelectedProject(project);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const getRelatedProjects = (current) => {
    return projects
      .filter((p) => p.category === current.category && p.id !== current.id)
      .slice(0, 3);
  };

  return (
    <div className="project-page-root">
      <style>{inlineStyles}</style>
      <Navbar />

      {selectedProject ? (
        /* --- RICH PROPERTY DETAIL VIEW --- */
        <div style={{ paddingBottom: "60px" }}>
          {/* Detail Hero Header */}
          <div className="detail-hero-banner" style={{ backgroundImage: `url(${selectedProject.image})` }}>
            <div className="detail-hero-overlay">
              <div style={{ maxWidth: "1240px", width: "100%", margin: "0 auto" }}>
                {/* Navigation Breadcrumb */}
                <div style={{ display: "flex", alignItems: "center", gap: "8px", color: "rgba(255,255,255,0.8)", fontSize: "0.85rem", marginBottom: "12px" }}>
                  <span style={{ cursor: "pointer" }} onClick={() => (window.location.href = "/")}>Home</span>
                  <FaChevronRight size={10} />
                  <span style={{ cursor: "pointer" }} onClick={() => setSelectedProject(null)}>Projects</span>
                  <FaChevronRight size={10} />
                  <span style={{ color: theme.accentLight, fontWeight: "600" }}>{selectedProject.name}</span>
                </div>

                <h1 style={{ color: "#FFF", fontSize: "2.25rem", fontWeight: "700", lineHeight: "1.2" }}>
                  {selectedProject.name}
                </h1>
              </div>
            </div>
          </div>

          {/* Detail Split Body */}
          <div className="detail-split-container">
            {/* Left Box: Large Media Display & Overview */}
            <div>
              <div style={{ backgroundColor: theme.bgCard, borderRadius: "16px", padding: "8px", border: `1px solid ${theme.border}`, boxShadow: theme.shadowSm, marginBottom: "24px" }}>
                <img
                  src={selectedProject.image}
                  alt={selectedProject.name}
                  style={{ width: "100%", height: "420px", objectFit: "cover", borderRadius: "12px" }}
                />
              </div>

              {selectedProject.description && (
                <div style={{ backgroundColor: theme.bgCard, borderRadius: "16px", padding: "28px", border: `1px solid ${theme.border}`, boxShadow: theme.shadowSm }}>
                  <h3 style={{ fontSize: "1.25rem", fontWeight: "700", color: theme.primary, marginBottom: "12px" }}>
                    Project Description
                  </h3>
                  <p style={{ color: theme.textMuted, lineHeight: "1.7", fontSize: "1rem" }}>
                    {selectedProject.description}
                  </p>
                </div>
              )}
            </div>

            {/* Right Box: Specifications Sidebar */}
            <div>
              <div style={{ backgroundColor: theme.bgCard, borderRadius: "16px", padding: "28px", border: `1px solid ${theme.border}`, boxShadow: theme.shadowMd, position: "sticky", top: "90px" }}>
                <button
                  onClick={() => setSelectedProject(null)}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    color: theme.accent,
                    backgroundColor: theme.accentLight,
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "20px",
                    fontWeight: "600",
                    fontSize: "0.85rem",
                    cursor: "pointer",
                    marginBottom: "20px",
                  }}
                >
                  <FaArrowLeft /> Back to Listings
                </button>

                <h3 style={{ fontSize: "1.25rem", fontWeight: "700", color: theme.primary, marginBottom: "20px", borderBottom: `1px solid ${theme.border}`, paddingBottom: "12px" }}>
                  Key Specifications
                </h3>

                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                  {/* Location */}
                  <div style={{ display: "flex", gap: "14px", alignItems: "flex-start" }}>
                    <div style={{ backgroundColor: theme.bgSubtle, padding: "12px", borderRadius: "10px", color: theme.accent }}>
                      <FaMapMarkerAlt size={20} />
                    </div>
                    <div>
                      <span style={{ fontSize: "0.8rem", color: theme.textMuted, display: "block", textTransform: "uppercase", fontWeight: "600" }}>Location</span>
                      <strong style={{ fontSize: "1rem", color: theme.primary }}>{selectedProject.country}</strong>
                    </div>
                  </div>

                  {/* Category */}
                  <div style={{ display: "flex", gap: "14px", alignItems: "flex-start" }}>
                    <div style={{ backgroundColor: theme.bgSubtle, padding: "12px", borderRadius: "10px", color: theme.accent }}>
                      <FaTags size={20} />
                    </div>
                    <div>
                      <span style={{ fontSize: "0.8rem", color: theme.textMuted, display: "block", textTransform: "uppercase", fontWeight: "600" }}>Category</span>
                      <strong style={{ fontSize: "1rem", color: theme.primary }}>{selectedProject.category}</strong>
                    </div>
                  </div>

                  {/* Scope of Work */}
                  {selectedProject.scope_of_work && (
                    <div style={{ display: "flex", gap: "14px", alignItems: "flex-start" }}>
                      <div style={{ backgroundColor: theme.bgSubtle, padding: "12px", borderRadius: "10px", color: theme.accent }}>
                        <FaTasks size={20} />
                      </div>
                      <div>
                        <span style={{ fontSize: "0.8rem", color: theme.textMuted, display: "block", textTransform: "uppercase", fontWeight: "600" }}>Scope of Work</span>
                        <strong style={{ fontSize: "0.95rem", color: theme.primary, lineHeight: "1.4", display: "block", marginTop: "2px" }}>
                          {selectedProject.scope_of_work}
                        </strong>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Related Projects Section */}
          {getRelatedProjects(selectedProject).length > 0 && (
            <div style={{ maxWidth: "1240px", margin: "40px auto 0", padding: "0 20px" }}>
              <h3 style={{ fontSize: "1.5rem", fontWeight: "700", color: theme.primary, marginBottom: "20px" }}>
                Similar Developments
              </h3>
              <div className="projects-grid">
                {getRelatedProjects(selectedProject).map((related) => (
                  <div key={related.id} className="project-card" onClick={() => handleProjectClick(related)}>
                    <div className="project-card-img-wrapper">
                      <img src={related.image} alt={related.name} className="project-card-img" />
                      <span className="project-badge">{related.category}</span>
                    </div>
                    <div className="project-card-body">
                      <h4 style={{ fontSize: "1rem", fontWeight: "700", color: theme.primary, marginBottom: "8px" }}>{related.name}</h4>
                      <p style={{ fontSize: "0.85rem", color: theme.textMuted }}>{related.country}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ) : (
        /* --- MAIN LISTINGS VIEW --- */
        <div style={{ padding: "40px 0" }}>
          <div className="projects-layout">
            {/* Sidebar Filter Controls */}
            <aside>
              <div style={{ backgroundColor: theme.bgCard, borderRadius: "16px", padding: "24px", border: `1px solid ${theme.border}`, boxShadow: theme.shadowSm, position: "sticky", top: "90px" }}>
                <h3 style={{ fontSize: "1.1rem", fontWeight: "700", color: theme.primary, marginBottom: "20px", display: "flex", alignItems: "center", gap: "8px" }}>
                  <FaBuilding color={theme.accent} /> Filter Portfolio
                </h3>

                {/* Keyword Search */}
                <div style={{ marginBottom: "20px" }}>
                  <label style={{ display: "block", fontSize: "0.8rem", fontWeight: "600", color: theme.textMuted, marginBottom: "6px" }}>Search Keyword</label>
                  <div style={{ display: "flex", alignItems: "center", backgroundColor: theme.bgSubtle, border: `1px solid ${theme.border}`, borderRadius: "8px", padding: "0 12px" }}>
                    <FaSearch color={theme.textMuted} size={14} />
                    <input
                      type="text"
                      placeholder="Search title or scope..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{ width: "100%", padding: "10px", border: "none", outline: "none", backgroundColor: "transparent", fontSize: "0.875rem", color: theme.textDark }}
                    />
                  </div>
                </div>

                {/* Category Filter */}
                <div style={{ marginBottom: "20px" }}>
                  <label style={{ display: "block", fontSize: "0.8rem", fontWeight: "600", color: theme.textMuted, marginBottom: "6px" }}>Category</label>
                  <select
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                    style={{ width: "100%", padding: "10px 12px", borderRadius: "8px", border: `1px solid ${theme.border}`, backgroundColor: theme.bgSubtle, color: theme.textDark, fontSize: "0.875rem", cursor: "pointer", outline: "none" }}
                  >
                    <option value="">All Categories ({categories.length})</option>
                    {categories.map((cat, i) => (
                      <option key={i} value={cat}>{cat}</option>
                    ))}
                  </select>
                </div>

                {/* Country Filter */}
                <div style={{ marginBottom: "20px" }}>
                  <label style={{ display: "block", fontSize: "0.8rem", fontWeight: "600", color: theme.textMuted, marginBottom: "6px" }}>Location / Country</label>
                  <select
                    value={selectedCountry}
                    onChange={(e) => setSelectedCountry(e.target.value)}
                    style={{ width: "100%", padding: "10px 12px", borderRadius: "8px", border: `1px solid ${theme.border}`, backgroundColor: theme.bgSubtle, color: theme.textDark, fontSize: "0.875rem", cursor: "pointer", outline: "none" }}
                  >
                    <option value="">All Countries ({countries.length})</option>
                    {countries.map((c, i) => (
                      <option key={i} value={c}>{c}</option>
                    ))}
                  </select>
                </div>

                {/* Reset Filters */}
                {(selectedCategory || selectedCountry || searchQuery) && (
                  <button
                    onClick={() => {
                      setSelectedCategory("");
                      setSelectedCountry("");
                      setSearchQuery("");
                    }}
                    style={{ width: "100%", backgroundColor: theme.bgSubtle, color: theme.accent, border: `1px solid ${theme.border}`, padding: "8px", borderRadius: "6px", fontSize: "0.85rem", fontWeight: "600", cursor: "pointer" }}
                  >
                    Reset Filters
                  </button>
                )}
              </div>
            </aside>

            {/* Main Portfolio List */}
            <main>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
                <div>
                  <h2 style={{ fontSize: "1.5rem", fontWeight: "700", color: theme.primary }}>Project Directory</h2>
                  <p style={{ fontSize: "0.9rem", color: theme.textMuted }}>Explore engineered luxury and architectural masterpieces</p>
                </div>
                <span style={{ backgroundColor: theme.accentLight, color: theme.accent, padding: "6px 14px", borderRadius: "20px", fontWeight: "600", fontSize: "0.85rem" }}>
                  {filteredProjects.length} Properties
                </span>
              </div>

              {filteredProjects.length > 0 ? (
                <div className="projects-grid">
                  {filteredProjects.map((project) => (
                    <div key={project.id} className="project-card" onClick={() => handleProjectClick(project)}>
                      <div className="project-card-img-wrapper">
                        <img src={project.image} alt={project.name} className="project-card-img" />
                        <span className="project-badge">{project.category}</span>
                      </div>
                      <div className="project-card-body">
                        <div style={{ display: "flex", alignItems: "center", gap: "6px", color: theme.accent, fontSize: "0.8rem", fontWeight: "600", marginBottom: "6px" }}>
                          <FaMapMarkerAlt /> {project.country}
                        </div>
                        <h3 style={{ fontSize: "1.05rem", fontWeight: "700", color: theme.primary, marginBottom: "8px", lineHeight: "1.3" }}>
                          {project.name}
                        </h3>
                        <div style={{ marginTop: "auto", paddingTop: "12px", borderTop: `1px solid ${theme.border}`, display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "0.85rem", color: theme.accent, fontWeight: "600" }}>
                          <span>View Details</span>
                          <FaArrowRight size={12} />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{ backgroundColor: theme.bgCard, borderRadius: "16px", padding: "60px 20px", textAlign: "center", border: `1px solid ${theme.border}` }}>
                  <FaRegFolderOpen size={48} color={theme.textMuted} style={{ marginBottom: "16px" }} />
                  <h3 style={{ fontSize: "1.1rem", fontWeight: "600", color: theme.primary }}>No matching projects found</h3>
                  <p style={{ color: theme.textMuted, fontSize: "0.9rem", marginTop: "4px" }}>Try broadening your search or resetting the active filters.</p>
                </div>
              )}
            </main>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Project;